import React, { useEffect, useState } from "react"
import { Container, Card, CardBody, Table, Button, Input } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getLedgerFeatures, saveLedgerFeatures } from "../../services/developer"
import { toastError, toastSuccess } from "../../helpers/msg_helper"

const FEATURES = [
  { key: "feat_bill_wise", label: "Bill Wise" },
  { key: "feat_taxable", label: "Taxable" },
  { key: "feat_interest", label: "Interest Calc." },
  { key: "feat_tax_registration", label: "Tax Registration" },
  { key: "feat_subledger", label: "Subledger" },
]

const LedgerFeatures = () => {
  document.title = "Ledger Features | Developer"
  const [rows, setRows] = useState([])
  const [search, setSearch] = useState("")
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    ;(async () => {
      try { const r = await getLedgerFeatures(); setRows(r?.data || []) }
      catch (e) { toastError(e?.message || "Failed to load ledger features") }
    })()
  }, [])

  const toggle = (id, key) => setRows(rs => rs.map(r => (r.id === id ? { ...r, [key]: r[key] ? 0 : 1 } : r)))

  const save = async () => {
    setSaving(true)
    try { await saveLedgerFeatures(rows); toastSuccess("Ledger features saved") }
    catch (e) { toastError(e?.message || "Save failed") }
    finally { setSaving(false) }
  }

  const q = search.toLowerCase()
  const filtered = rows.filter(r => !q || (r.name || "").toLowerCase().includes(q) || (r.code || "").toLowerCase().includes(q))

  return (
    <div className="page-content report-page">
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <Breadcrumbs title="Developer" breadcrumbObject={[
            { title: "Developer", link: "/developer" },
            { title: "Ledger Features", link: "#" },
          ]} />
          <Button color="primary" size="sm" className="mb-3" onClick={save} disabled={saving}>Save</Button>
        </div>
        <Card>
          <CardBody>
            <p className="text-muted" style={{ fontSize: 13 }}>
              Choose which features the <strong>Create Ledger</strong> form shows for each Nature of Account.
              Defaults match the previous built-in behaviour; changes here apply immediately on the ledger form.
            </p>
            <Input bsSize="sm" placeholder="Search nature / code…" value={search}
              onChange={e => setSearch(e.target.value)} style={{ maxWidth: 300 }} className="mb-3" />
            <Table bordered className="align-middle tnt-table mb-0" style={{ fontSize: 13 }}>
              <thead>
                <tr>
                  <th style={{ minWidth: 260 }}>Nature of Account</th>
                  {FEATURES.map(f => <th key={f.key} className="text-center">{f.label}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id}>
                    <td>{r.name}{r.code ? <small className="text-muted d-block">{r.code}</small> : null}</td>
                    {FEATURES.map(f => (
                      <td key={f.key} className="text-center">
                        <Input type="checkbox" checked={!!Number(r[f.key])} onChange={() => toggle(r.id, f.key)} />
                      </td>
                    ))}
                  </tr>
                ))}
                {!filtered.length && <tr><td colSpan={FEATURES.length + 1} className="text-center text-muted">No account groups</td></tr>}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default LedgerFeatures
